import PageHero from "@/components/feature/PageHero";
import CtaBand from "@/components/feature/CtaBand";
import {
  companyIntro,
  companyValues,
  companyStats,
  milestones,
  teamMembers,
  honors,
} from "@/mocks/company";

const anchorNav = [
  { id: "intro", label: "企业介绍" },
  { id: "values", label: "价值理念" },
  { id: "milestones", label: "发展历程" },
  { id: "team", label: "核心团队" },
  { id: "honors", label: "荣誉资质" },
];

export default function About() {
  return (
    <div>
      <PageHero
        title="关于芒果传媒"
        subtitle="十八年专注影视内容制作与传媒服务，用影像记录时代，用内容连接人心。"
        image="https://readdy.ai/api/search-image?query=Modern%20media%20company%20office%20with%20warm%20lighting%20and%20large%20windows%2C%20professional%20creative%20workspace%2C%20cinematic%20wide%20shot%2C%20dark%20tones%2C%20no%20text&width=1920&height=700&seq=mango-about-hero&orientation=landscape"
        crumbs={[{ label: "关于我们" }]}
      />

      <nav className="sticky top-16 md:top-20 z-40 bg-background-50/95 backdrop-blur-md border-b border-background-200/80">
        <div className="container-site flex items-center gap-1 overflow-x-auto py-2">
          {anchorNav.map((a) => (
            <a
              key={a.id}
              href={`#${a.id}`}
              className="px-3.5 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              {a.label}
            </a>
          ))}
        </div>
      </nav>

      <section id="intro" className="bg-background-50 py-14 md:py-20 scroll-mt-32">
        <div className="container-site grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
              Company Profile
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3 mb-6">
              一家以内容为核心的传媒公司
            </h2>
            <div className="flex flex-col gap-4">
              {companyIntro.map((p, i) => (
                <p key={i} className="text-foreground-700 leading-relaxed text-sm md:text-base">
                  {p}
                </p>
              ))}
            </div>
          </div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-4 self-start">
            {companyStats.map((s) => (
              <div
                key={s.label}
                className="bg-secondary-50 rounded-lg p-5 border border-background-200/80"
              >
                <span className="font-heading font-extrabold text-2xl md:text-3xl text-primary-700 block">
                  {s.value}
                </span>
                <span className="text-xs md:text-sm text-foreground-600 mt-1 block">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="values" className="bg-secondary-50 py-14 md:py-20 scroll-mt-32">
        <div className="container-site">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
              Our Values
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3">
              支撑我们一路前行的信念
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {companyValues.map((v) => (
              <div
                key={v.title}
                className="bg-background-50 rounded-lg p-6 border border-background-200/80"
              >
                <span className="w-14 h-14 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className={`${v.icon} text-3xl text-accent-700`}></i>
                </span>
                <h3 className="font-heading font-bold text-lg text-foreground-950 mt-5">{v.title}</h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="milestones" className="bg-background-50 py-14 md:py-20 scroll-mt-32">
        <div className="container-site">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
              Milestones
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3">
              发展历程
            </h2>
          </div>
          <div className="relative mt-12 max-w-3xl mx-auto">
            <div className="absolute left-[7px] md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-1/2"></div>
            <div className="flex flex-col gap-8">
              {milestones.map((m, i) => (
                <div
                  key={m.year}
                  className={`relative pl-8 md:pl-0 md:w-1/2 ${
                    i % 2 === 0 ? "md:pr-10 md:text-right" : "md:ml-auto md:pl-10"
                  }`}
                >
                  <span
                    className={`absolute left-0 md:left-auto top-1.5 w-4 h-4 rounded-full bg-primary-500 ring-4 ring-primary-100 ${
                      i % 2 === 0 ? "md:-right-2" : "md:-left-2"
                    }`}
                  ></span>
                  <span className="font-heading font-extrabold text-xl md:text-2xl text-primary-700">
                    {m.year}
                  </span>
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 mt-1">
                    {m.title}
                  </h3>
                  <p className="text-sm text-foreground-600 mt-1 leading-relaxed">{m.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="team" className="bg-secondary-50 py-14 md:py-20 scroll-mt-32">
        <div className="container-site">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
              Our Team
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3">
              核心团队
            </h2>
            <p className="text-foreground-600 mt-4 text-sm md:text-base">
              一群热爱内容、彼此信任的创作者，共同构成了芒果传媒的创作底色。
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {teamMembers.map((t) => (
              <div key={t.name} className="bg-background-50 rounded-lg overflow-hidden border border-background-200/80">
                <div className="w-full aspect-[4/5] overflow-hidden">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    title={`${t.name} - 芒果传媒`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-heading font-bold text-lg text-foreground-950">{t.name}</h3>
                  <span className="text-sm text-primary-700 font-medium">{t.role}</span>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{t.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="honors" className="bg-background-50 py-14 md:py-20 scroll-mt-32">
        <div className="container-site">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
              Honors & Qualifications
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3">
              荣誉与资质
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
            {honors.map((h) => (
              <div
                key={h.title}
                className="flex items-start gap-4 bg-secondary-50 rounded-lg p-5 border border-background-200/80"
              >
                <span className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-award-fill text-2xl text-primary-700"></i>
                </span>
                <div>
                  <span className="text-xs font-semibold text-accent-700">{h.year} 年度</span>
                  <h3 className="font-heading font-bold text-base text-foreground-950 mt-1">
                    {h.title}
                  </h3>
                  <p className="text-xs text-foreground-600 mt-1">{h.issuer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}